<template>

  <v-container v-if="availability && hotel && !confirmed" fluid style="max-width: 1280px;">

    <v-overlay :value="searching">
      <v-progress-circular
        color="white"
        size="48"
        indeterminate
      />
    </v-overlay>

    <v-row no-gutters>
      <v-col cols="12">
        <im-title-bar
          :title="hotel.name"
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <im-search-bar
          :check_in.sync="query.check_in"
          :check_out.sync="query.check_out"
          :rooms.sync="query.rooms"
          :currency.sync="query.currency"
          @search="searchAvailability()"
        />
      </v-col>
    </v-row>

    <v-row no-gutters v-if="availability.rooms.length > 0">
      <v-col cols="12" md="8">

        <im-room-list
          :hotel="hotel"
          :availability="availability"
        />

        <im-hotel-info
          :hotel="hotel"
        />

      </v-col>
      <v-col cols="12" md="4">

        <im-desktop-summary
          v-if="$vuetify.breakpoint.mdAndUp"
          :availability="availability"
          @book="goToReservation()"
        />

        <im-mobile-summary
          v-if="$vuetify.breakpoint.smAndDown"
          :availability="availability"
          @book="goToReservation()"
        />

      </v-col>
    </v-row>

    <v-row no-gutters v-if="availability.rooms.length <= 0">
      <v-col cols="12">
        <v-alert type="info" class="ma-2">
          Nu există camere în intervalul selectat.
          <br>
          Vă rugăm să încercați în altă perioadă.
        </v-alert>
      </v-col>

      <v-col cols="12" md="8" offset-md="2">
        <im-hotel-info
          :hotel="hotel"
        />
      </v-col>
          
    </v-row>

  </v-container>

  <v-container v-else-if="!availability || !hotel" fluid fill-height>
    <v-overlay>
      <v-progress-circular
        color="white"
        size="48"
        indeterminate
      />
    </v-overlay>
  </v-container>


</template>

<script>

  import IMTitleBar from '../components/items/TitleBar.vue';
  import IMSearchBar from '../components/items/SearchBar.vue';
  import IMRoomList from '../components/items/RoomList.vue';
  import IMHotelInfo from '../components/items/HotelInfo.vue';
  import IMDesktopSummary from '../components/items/SummaryDesktop.vue';
  import IMMobileSummary from '../components/items/SummaryMobile.vue';

  export default {

    components: {
      'im-title-bar': IMTitleBar,
      'im-search-bar': IMSearchBar,
      'im-hotel-info': IMHotelInfo,
      'im-room-list': IMRoomList,
      'im-desktop-summary': IMDesktopSummary,
      'im-mobile-summary': IMMobileSummary
    },

    data() {
      return {

        hotel: JSON.parse(sessionStorage.getItem('hotel')) || null,
        availability: JSON.parse(sessionStorage.getItem('availability')) || null,
        confirmed: JSON.parse(sessionStorage.getItem('confirmed')) || null,

        searching: false,

        query: {
          check_in: this.$route.query.ci || this.$moment().format('YYYY-MM-DD'),
          check_out: this.$route.query.co || this.$moment().add(1, 'days').format('YYYY-MM-DD'),
          rooms: [{adults: [{age: 'a'}, {age: 'a'}], children: []}],
          currency: 'RON'
        }

      }
    },

    created() {
      if (!this.hotel || !this.availability) {
        this.load();
      }
    },

    methods: {

      async load() {
        await this.searchHotel();
        await this.searchAvailability();
        this.generatePageMeta()
      },

      async searchHotel() {
        try {
          this.searching = true;
          this.hotel = await this.$axios.getHotel();
          sessionStorage.setItem('hotel', JSON.stringify(this.hotel));
        } catch (e) {
          if (e.code === 404) await this.$router.push('404');
          if (e.code === 500) await this.$router.push('500');
        } finally {
          this.searching = false;
        }
      },

      async searchAvailability() {
        try {
          this.searching = true;
          this.availability = await this.$axios.getAvailability(this.hotel, this.query);
          sessionStorage.setItem('availability', JSON.stringify(this.availability));
        } catch (e) {
          if (e.code === 404) await this.$router.push('404');
          if (e.code === 500) await this.$router.push('500');
        } finally {
          this.searching = false;
        }
      },

      goToReservation() {
        this.$router.push('/reservation')
      },

      generatePageMeta() {
        this.setCanonicalLink();
        this.appendHeadElement('meta', {
          'name': 'title',
          'content': 'Oferte la ' + this.hotel.name + ' din ' + this.hotel.city
        });
        this.appendHeadElement('meta', {
          'name': 'description',
          'content': this.hotel.description.ro.substr(0, 150) + ' ...'
        });
        this.appendOpenGraphElements();
      },

      setCanonicalLink() {
        this.appendHeadElement('link', {
          'rel': 'canonical',
          'href': 'https://www.helloromania.com/cazare-' + this.hotel.city.toLowerCase() + '/' + this.hotel.slug + '-' + this.hotel.id
        })
      },

      appendOpenGraphElements() {
        this.appendHeadElement('meta', {
          'property': 'og:type',
          'content': 'website'
        });
        this.appendHeadElement('meta', {
          'property': 'og:url',
          'content': window.location.href
        });
        this.appendHeadElement('meta', {
          'property': 'og:title',
          'content': 'Oferte la ' + this.hotel.name + ' din ' + this.hotel.city
        });
        this.appendHeadElement('meta', {
          'property': 'og:description',
          'content': this.hotel.description.ro.substr(0, 150) + ' ...'
        });
        this.appendHeadElement('meta', {
          'property': 'og:image',
          'content': this.hotel.media[0].url.original
        });

      },

      appendHeadElement(name, attributes) {
        let element = document.createElement(name);
        for (let attribute in attributes) {
          element.setAttribute(attribute, attributes[attribute]);
        }
        document.head.appendChild(element);
      }
    }

  }
</script>
